(() => {
  const createVideoPlayer = (frame, heading) => {
    const source = frame.getAttribute('src') || '';
    const idMatch = source.match(/\/embed\/([^?&/]+)/);

    if (!idMatch) return frame;

    const videoId = idMatch[1];
    const button = document.createElement('button');
    const image = document.createElement('img');
    const playIcon = document.createElement('span');

    button.type = 'button';
    button.className = 'ice-video-player';
    button.setAttribute('aria-label', frame.title || `Play ${heading || 'video'}`);

    image.src = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
    image.alt = '';
    image.loading = 'lazy';
    image.addEventListener('error', () => {
      image.src = `https://i.ytimg.com/vi/${videoId}/mqdefault.jpg`;
    }, { once: true });

    playIcon.className = 'ice-video-player__play';
    playIcon.setAttribute('aria-hidden', 'true');

    button.append(image, playIcon);
    button.addEventListener('click', () => {
      const player = document.createElement('iframe');
      player.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
      player.title = frame.title || heading || 'Video';
      player.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      player.allowFullscreen = true;
      player.className = 'ice-video-player__iframe';
      button.replaceWith(player);
    });

    return button;
  };

  const buildVideoGrid = (scope = document) => {
    const page = scope.querySelector?.('.ice-page--videos');
    const content = page?.querySelector('.prose');

    if (!content || content.dataset.iceVideoGrid === 'ready') return;

    const frames = Array.from(content.querySelectorAll('iframe'));
    if (frames.length === 0) return;

    const grid = document.createElement('div');
    grid.className = 'ice-video-grid';

    frames.forEach((frame) => {
      let mediaBlock = frame;

      while (mediaBlock.parentElement && mediaBlock.parentElement !== content) {
        mediaBlock = mediaBlock.parentElement;
      }

      const relatedContent = [];
      let candidate = mediaBlock.previousElementSibling;

      while (candidate && !candidate.matches('iframe') && !candidate.querySelector('iframe')) {
        if (candidate.matches('h2, h3, p')) relatedContent.unshift(candidate);
        if (candidate.matches('h2, h3')) break;
        candidate = candidate.previousElementSibling;
      }

      if (mediaBlock !== frame) {
        mediaBlock.querySelectorAll('h2, h3, p').forEach((element) => {
          if (!element.querySelector('iframe') && !relatedContent.includes(element)) {
            relatedContent.push(element);
          }
        });
      }

      const card = document.createElement('article');
      const copy = document.createElement('div');
      card.className = 'ice-video-card';
      copy.className = 'ice-video-card__copy';
      const headingElement = relatedContent.find((element) => element.matches('h2, h3'));

      if (headingElement) {
        headingElement.textContent = headingElement.textContent.replace(/^\s*\d+[\uFE0F\u20E3]*\s*/u, '').trim();
      }

      relatedContent.forEach((element) => {
        element.querySelectorAll('[style]').forEach((styledElement) => styledElement.style.removeProperty('color'));
      });

      const heading = headingElement?.textContent.trim();
      const player = createVideoPlayer(frame, heading);

      relatedContent.forEach((element) => copy.appendChild(element));

      if (player === frame && mediaBlock !== frame) {
        card.appendChild(mediaBlock);
      } else {
        mediaBlock.remove();
        card.appendChild(player);
      }

      card.appendChild(copy);
      grid.appendChild(card);
    });

    content.prepend(grid);
    content.dataset.iceVideoGrid = 'ready';
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => buildVideoGrid());
  } else {
    buildVideoGrid();
  }

  document.addEventListener('shopify:section:load', (event) => buildVideoGrid(event.target));
})();
